import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';

export class MaeUsuarioE {
c_usuario:Number;
x_usuario:String;
x_nombres:String;
x_ape_pat:String;
x_ape_mat:String;
x_nro_documento:String;
c_doc_identidad:Number;
x_correo:String;
x_clave:String;
c_oficina:Number;
c_perfil:Number;
c_estado:Number;
auditoriaBeanM:AuditoriaBeanM;
serviceCredencialesM:ServiceCredencialesM;
}

export class MaeUsuarioM {
    c_usuario:Number;
    x_usuario:String;
    x_nombres:String;
    x_ape_pat:String;
    x_ape_mat:String;
    x_nro_documento:String;
    //c_doc_identidad:Number;
    //x_doc_identidad:String;
    x_correo:String;
    x_clave:String;
    c_oficina:Number;
    x_oficina:String;
    c_perfil:Number;
    x_perfil:String;
    c_estado:Number;
    x_estado:String;
}


export class MaeUsuarioFil {
  P_NOMBRES:string;
  P_C_OFICINA:string;
  P_X_ESTADO:string;
}


export class VersionM
{
  version:String;
}
